/**
 * Breadcrumb - shared breadcrumb nav (Story #5351 W1-T4).
 * Replaces the hand-rolled `<nav>...<ChevronRight/>...` pattern duplicated in
 * IngestionJobDetail.tsx and IngestionWizard.tsx.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  /** Route path. Omit for the current (last) crumb, rendered as plain text. */
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => (
  <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-gray-500 mb-4">
    {items.map((item, i) => (
      <React.Fragment key={`${item.label}-${i}`}>
        {i > 0 && <ChevronRight className="w-3 h-3" aria-hidden="true" />}
        {item.to ? (
          <Link to={item.to} className="hover:text-gray-700">{item.label}</Link>
        ) : (
          <span className="text-gray-900 font-medium">{item.label}</span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumb;
